import React, { useState } from "react";

const PaginationText = () => {
  const totalItems = 50; // Example total items
  const itemsPerPage = 10;

  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

const pager = (
        <div>
      <p>
        Page {currentPage} of {totalPages}
      </p>
      <button
        onClick={handlePrevPage}
        disabled={currentPage === 1} // Disable Prev button on first page
      >
        Previous
      </button>
      <button
        onClick={handleNextPage}
        disabled={currentPage >= totalPages} // Disable Next button on last page
      >
        Next
      </button>
    </div>
)

  return (
    <>
      <section className="content-header">
        <h1>PAGINATION TEXT</h1>
      </section>

      <section className="content">
        <div className="box">
          <div className="box-body">
            <div className="panel panel-default panel-br-4">
              <div className="panel-heading">
                <div className="row">
                  <div className="col-sm-12">
                    <h4 className="panel-title"></h4>
                  </div>
                </div>
              </div>
              <div className="panel-body">{pager}</div>
              <div className="panel-footer"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PaginationText;
